import { ModulesMap, ModulesConfigMap } from '../data/modulesMaps'

export default {
  getInProgressFieldWorks: {
    apiServiceMethodName:
      ModulesConfigMap[ModulesMap.DONE_WORKS_IN_PROGRESS_FIELD_WORKS].GET_IN_PROGRESS_FIELD_WORKS
  },
}